import { ru } from './ru';

export const kk = {
  ...ru,
  common: {
    ...ru.common,
    loading: 'Жүктелуде...',
    back: 'Артқа',
    save: 'Сақтау',
    cancel: 'Болдырмау',
    delete: 'Жою',
    edit: 'Өңдеу',
    add: 'Қосу',
    create: 'Жасау',
    apply: 'Қолдану',
    confirm: 'Растау',
    yes: 'Иә',
    no: 'Жоқ',
    close: 'Жабу',
    next: 'Келесі',
    previous: 'Артқа',
    skip: 'Өткізу',
    done: 'Дайын',
    error: 'Қате',
    success: 'Сәтті',
    saving: 'Сақталуда...',
    deleting: 'Жойылуда...',
    optional: '(міндетті емес)',
    required: 'міндетті',
    chooseFile: 'Файл таңдау',
    nothingFound: 'Ештеңе табылмады',
    untitled: 'Атаусыз',
    description: 'Сипаттама',
    title: 'Атауы',
    name: 'Аты',
    date: 'Күні',
    actions: 'Әрекеттер',
    all: 'Барлығы',
    status: 'Статус',
    category: 'Санат',
    amount: 'Сома',
    filters: 'Сүзгілер',
    search: 'Іздеу',
    selected: 'Таңдалды',
    currency: 'Валюта',
  },
  errors: {
    ...ru.errors,
    generic: 'Қате пайда болды. Кейінірек қайталап көріңіз.',
    authTitle: 'Авторизация қатесі',
    devMode: 'Әзірлеу режимі',
    devModeHint: 'Толық функционал үшін қолданбаны Telegram арқылы ашыңыз',
    notFound: 'Табылмады',
    forbidden: 'Қолжетімділік жоқ',
    loadTitle: 'Жүктеу мүмкін болмады',
    loadHint: 'Интернетті тексеріп, қайталап көріңіз.',
    reload: 'Жаңарту',
    networkError: 'Желі қатесі',
  },
  language: {
    label: 'Тіл',
    ru: 'Русский',
    en: 'English',
    kk: 'Қазақша',
  },
  announcement: {
    eyebrow: 'Не жаңалық',
    next: 'Әрі қарай',
    gotIt: 'Түсінікті',
  },
  tabs: {
    collections: 'Іріктемелер',
    dashboard: 'Басты',
    expenses: 'Шығындар',
    materials: 'Материалдар',
    stages: 'Кезеңдер',
    profile: 'Профиль',
  },
  login: {
    ...ru.login,
    title: 'etap-қа кіру',
    subtitle: 'Жөндеуді басқаруды жалғастыру үшін кіріңіз',
    telegramBtn: 'Telegram арқылы кіру',
    telegramSigningIn: 'Кіру…',
    telegramConfirm: 'Telegram терезесінде кіруді растаңыз. Терезе ашылмаса, қалқымалы терезелерге рұқсат беріп, қайталап көріңіз.',
    telegramUnavailable: 'Telegram жүктелмеді. Байланысты тексеріп, қайталап көріңіз.',
    telegramFailed: 'Telegram арқылы кіру мүмкін болмады. Қайталап көріңіз.',
    telegramExpired: 'Кіру сеансы жаңартылды. Түймені қайта басыңыз.',
    retry: 'Қайталап көру',
    cancel: 'Бас тарту',
    yandexBtn: 'Яндекс арқылы кіру',
    or: 'немесе',
    benefits: 'Қауіпсіз кіру · Құпиясөз қажет емес',
    miniAppHint: 'Немесе Telegram ішінде пайдаланыңыз —',
    miniAppLink: 'Mini App ашу',
  },
  legal: {
    loginNotice: 'Кіре отырып, сіз мыналарды қабылдайсыз:',
    loginTerms: 'Пайдалану шарттары',
    loginConsentPrefix: 'және',
    loginConsent: 'дербес деректерді өңдеуге келісім бересіз',
    loginPolicyPrefix: '—',
    loginPolicy: 'Құпиялылық саясатына сәйкес',
    documents: 'Құжаттар',
    privacy: 'Құпиялылық саясаты',
    terms: 'Пайдалану шарттары',
    consent: 'Деректерді өңдеуге келісім',
    cookieText: 'Қызмет жұмыс істеуі және ыңғайлы болуы үшін біз cookie және Яндекс Метриканы пайдаланамыз. Жалғастыра отырып, сіз келісесіз:',
    cookieLink: 'деректерді өңдеу',
    cookieOk: 'Түсінікті',
  },
  onboarding: {
    ...ru.onboarding,
    step1Title: 'etap-қа қош келдіңіз',
    step1Desc: 'Жөндеу мен бюджетті бір жерден бақылаңыз.',
    step2Title: 'Жоба жасаңыз',
    step2Desc: 'Жобаға атау беріп, бюджетті көрсетіңіз.',
    step3Title: 'Команданы шақырыңыз',
    step3Desc: '5 адамға дейін — серіктес, туыс, мердігер.',
    step4Title: 'Дайын!',
    step4Desc: 'Шығындар мен кезеңдерді командамен бірге басқарыңыз.',
    skip: 'Өткізу',
    start: 'Бастау',
    budgetOptionalHint: 'Міндетті емес — кейінірек қосуға болады',
  },
  stories: {
    report: {
      title: 'Жаңа есеп',
      desc: 'Жоба бойынша жаңа есеп дайын',
      cta: 'Есепті ашу',
    },
    poll: {
      thanks: 'Жауабыңыз үшін рахмет',
      thanksSub: 'Пікіріңіз ескерілді және өнімді жақсартуға көмектеседі.',
      step: '{{total}} сұрақтың {{current}}-сі',
    },
    renovation: {
      day: {
        circle: 'Жөндеу күні',
        slideTitle: 'Бүгін жөндеудің {{day}}-күні',
        slideSub: 'Прогресті қадағалап, жөндеуді бақылауда ұстаңыз.',
      },
      expenses: {
        title: 'Шығындар',
        desc: 'Жұмыс пен материал шығындарын тіркеңіз — ай және барлық жөндеу бойынша көріңіз',
      },
      stages: {
        title: 'Кезеңдер',
        desc: 'Жөндеуді кезеңдер бойынша жоспарлаңыз — прогресті нақты уақытта бақылаңыз',
      },
      materials: {
        title: 'Сатып алу',
        desc: 'Материалдар тізімін жасаңыз, бағалар мен мәртебелерді тіркеңіз',
      },
      ai: {
        title: 'AI талдау',
        desc: 'AI сметаңызды зерттеп кеңес береді — бірнеше жазбадан кейін қол жетімді',
      },
      team: {
        title: 'Топ',
        desc: 'Серіктес немесе мердігерді сілтеме арқылы шақырыңыз — жобаға 5 адамға дейін',
      },
    },
    finance: {
      expenses: {
        title: 'Шығындар',
        desc: 'Шығындарды санат бойынша тіркеңіз, кез келген кезең бойынша аналитиканы қараңыз',
      },
      analytics: {
        title: 'Аналитика',
        desc: 'Санаттар бойынша диаграммалар мен талдау — ақшаңыз қайда кеткенін бірден көресіз',
      },
      multicurrency: {
        title: 'Мультивалюта',
        desc: 'Рубль, доллар, евро және крипто — барлық шығындар бір жобада',
      },
      ai: {
        title: 'AI кеңесші',
        desc: 'Ақылды шығын талдауы: аномалиялар, трендтер және бюджет ағындары',
      },
      report: {
        title: 'Есеп',
        desc: 'Апта сайынғы шығын есебі тікелей Telegram-ға',
      },
    },
  },
  profile: {
    ...ru.profile,
    title: 'Профиль',
    settings: 'Баптаулар',
    logout: 'Шығу',
    logoutAll: 'Барлық құрылғыдан шығу',
    language: 'Интерфейс тілі',
    defaultCurrency: 'Әдепкі валюта',
    weeklyReport: 'Апталық есеп',
    weeklyReportDesc: 'Жоба бойынша қысқаша есепті Telegram-да алыңыз',
    sendNow: 'Қазір жіберу',
    sendOk: 'Есеп Telegram-ға жіберілді',
    sendInProgress: 'Жіберілуде...',
    sendCooldown: 'Күніне бір рет жіберуге болады',
    selectProject: 'Есеп үшін жобаны таңдаңыз',
    enableReport: 'Есепті қосу',
    dayLabel: 'Апта күні',
    days: {
      0: 'Жексенбі',
      1: 'Дүйсенбі',
      2: 'Сейсенбі',
      3: 'Сәрсенбі',
      4: 'Бейсенбі',
      5: 'Жұма',
      6: 'Сенбі',
    },
    timeZone: 'Уақыт белдеуі',
    timeZoneAuto: 'Автоматты анықталды: {{tz}}',
    saving: 'Сақталуда...',
    saved: 'Сақталды',
    confirmLogout: 'Аккаунттан шығасыз ба?',
    confirmLogoutAll: 'Барлық құрылғыдан шығасыз ба?',
    support: 'Қолдау',
    feedback: 'Пікір қалдыру',
    aboutApp: 'Қолданба туралы',
    versionLabel: 'Нұсқа',
  },
  dashboard: {
    ...ru.dashboard,
    settingsTitle: 'Басты бет баптаулары',
    settingsHint: 'Алдымен не тұратынын таңдаңыз. Қалған блоктарды оң жақтағы көзбен жасыруға болады.',
    settingsMainBadge: 'басты',
    settingsShow: 'Көрсету',
    settingsHide: 'Жасыру',
    blockFinance: 'Бюджет',
    blockFinanceDesc: 'Жұмсалған, қалдық, жоспарланған шығындар',
    blockStages: 'Кезеңдер',
    blockStagesDesc: 'Ағымдағы кезең және жұмыс барысы',
    blockPlans: 'Жоспар',
    blockPlansDesc: 'Пәтер сызбасы, аудан және бөлмелер',
    blockMaterials: 'Материалдар',
    blockMaterialsDesc: 'Жөндеуге арналған сатып алу тізімі',
    blockReports: 'AI-есептер',
    blockReportsDesc: 'Шығындардың апталық талдауы',
    plansHeroEmpty: 'Пәтеріңіздің жоспарын сызыңыз — бөлме ауданы өзі есептеледі.',
    plansHeroOpen: 'Жоспарлағышты ашу',
    plansHeroCount_one: 'тағы {{count}}',
    plansHeroCount_other: 'тағы {{count}}',
    title: 'Басты',
    chooseProject: 'Жобаны таңдаңыз',
    chooseProjectHint: 'Бастау үшін алғашқы жобаңызды жасаңыз',
    newProject: 'Жаңа жоба',
    selectProjectLabel: 'Белсенді жоба',
    activeProject: 'Белсенді жоба',
    switchProject: 'Жобаны ауыстыру',
    settings: 'Жоба баптаулары',
    inviteMembers: 'Қатысушыларды шақыру',
    budgetTotal: 'Бюджет',
    spent: 'Жұмсалды',
    remaining: 'Қалды',
    overspent: 'Артық шығын',
    progress: 'Прогресс',
    quickActions: 'Жылдам әрекеттер',
    actionAddExpense: 'Шығын қосу',
    actionOpenStages: 'Кезеңдер',
    actionOpenMaterials: 'Тауар іріктемелері',
    actionOpenKanban: 'Канбан',
    recentExpenses: 'Соңғы шығындар',
    seeAll: 'Барлығы →',
    noExpenses: 'Әзірге шығын жоқ',
    addFirstExpense: 'Алғашқы шығынды қосыңыз',
    stagesProgress: 'Кезеңдер прогресі',
    noStages: 'Кезеңдер әлі жасалмаған',
    upcomingPlanned: 'Төлемді күтуде',
    of: 'ішінен',
    projectsCount_one: '{{count}} жоба',
    projectsCount_few: '{{count}} жоба',
    projectsCount_many: '{{count}} жоба',
    projectsCount_other: '{{count}} жоба',
    myProjects: 'Менің жобаларым',
    roleEditor: 'Редактор',
    roleViewer: 'Бақылаушы',
    membersWithCount: 'Қатысушылар ({{count}}/{{limit}})',
    editProject: 'Жобаны өңдеу',
    deleteCurrentProject: 'Ағымдағы жобаны жою',
    deleteOnlyProjectConfirm: 'Жобаны жойғыңыз келе ме? Бұл жалғыз жоба, барлық дерек жоғалады.',
    deleteProjectConfirm: '"{{title}}" жобасын жою керек пе? Барлық шығындар мен жоба деректері жойылады.',
    leaveProjectConfirm: '"{{title}}" жобасынан шығасыз ба?',
    monthSpent: 'ай ішінде',
    draftsCount_one: '{{count}} шығын',
    draftsCount_other: '{{count}} шығын',
    draftsOverRemaining: 'қалғаннан көп',
    plannedShort: 'Жоспарлануда',
    periodSpend: 'Кезең шығыны',
    nextStage: 'Келесі',
    quickRepairDay: 'Рем. күні',
    quickAi: 'AI есептер',
    progressUsed: '{{percent}}% игерілді',
    aiGateTitle: 'Прораб AI — шығын талдауы',
    aiGateTitleFinance: 'AI кеңесші — қаржы талдауы',
    aiGateDesc: 'Дәл талдау үшін жоба деректерін толтырып, алғашқы шығындарды енгізіңіз.',
    aiGateDescFinance: 'AI қаржыңызды талдауы үшін алғашқы шығындарды енгізіңіз.',
    areaRequired: 'Пәтер ауданы',
    notSpecified: 'Көрсетілмеген',
    specify: 'Көрсету',
    minExpenses: 'Кемінде 3 шығын',
    expensesEntered: '{{required}} ішінен {{count}} енгізілді',
    aiObservation_one: '{{count}} бақылау',
    aiObservation_few: '{{count}} бақылау',
    aiObservation_many: '{{count}} бақылау',
    aiObservation_other: '{{count}} бақылау',
    aiLabelInfo: 'Бақылау',
    aiLabelWarning: 'Назар',
    aiLabelAlert: 'Маңызды',
    aiLabelTip: 'Кеңес',
    aiNoObservations: 'Әзірге бақылау жоқ',
    aiRefreshAvailable: 'Жаңарту қолжетімді',
    aiNextReport: 'Келесі есеп {{time}} кейін',
    details: 'Толығырақ',
    spentAllTime: 'Барлығы жұмсалды',
    allTime: 'барлық уақыт',
    currentPeriod: 'ағымдағы кезең',
    next14Days: 'келесі 14 күн',
    pricePerSqm: 'м² бағасы',
    createStagesHint: 'Прогресті бақылау үшін кезеңдер жасаңыз',
    start: 'Бастау →',
    products: 'Іріктемелер',
    shoppingList: 'Тауар іріктемелері',
    itemsCount: 'позиция: {{count}}',
    planPurchases: 'Сатып алуды жоспарлаңыз',
    collectionsPitch: 'Араластырғыш не плитка таңдап жүрсіз бе?',
    collectionsPitchSub: 'Дүкендердегі нұсқаларды сақтап, бағаларын салыстырыңыз',
    newBadge: 'Жаңа',
    weeklyReports: 'Апталық есептер',
    weeklyReportForProject: '"{{title}}" жобасы бойынша есеп әр {{day}} 10:00-де',
    weeklyReportGeneric: 'Telegram-дағы есеп әр {{day}} 10:00-де',
    reportDayAria: 'Есеп күні',
    sendReportNow: 'Есепті қазір жіберу',
    noProjectsForReport: 'Есеп үшін әзірге жоба жоқ',
    reportSent: 'Есеп Telegram-ға жіберілді',
    reportSendError: 'Есепті жіберу мүмкін болмады',
    supportQuestion: 'Мәселе туындады ма?',
    contactSupport: 'Қолдауға жазу',
    viewAnnouncements: 'Барлық жаңалықтар',
    weekdaysShort: {
      0: 'Жс',
      1: 'Дс',
      2: 'Сс',
      3: 'Ср',
      4: 'Бс',
      5: 'Жм',
      6: 'Сн',
    },
    weekdaysReport: {
      0: 'жексенбі',
      1: 'дүйсенбі',
      2: 'сейсенбі',
      3: 'сәрсенбі',
      4: 'бейсенбі',
      5: 'жұма',
      6: 'сенбі',
    },
    period: {
      day: 'күн',
      week: 'апта',
      month: 'ай',
      year: 'жыл',
      all: 'барлық уақыт',
    },
  },
  expenses: {
    ...ru.expenses,
    reportPromoTitle: 'Аптасына бір рет есеп',
    reportPromoText: 'Сіз қазірдің өзінде {{total}} жаздыңыз. Аптасына бір рет талдау жіберемін — ештеңе оқудың қажеті жоқ, ол өзі келеді.',
    reportPromoPoint1: 'Апта ішінде қанша және қандай санаттарға жұмсалды',
    reportPromoPoint2: 'Қай жерде лимиттен шықтыңыз және қай шоттар мерзімі өтті',
    reportPromoPoint3: 'Бюджет қалдығы неше аптаға жетеді',
    reportPromoAction: 'Есепті қосу',
    title: 'Шығындар',
    add: 'Шығын қосу',
    edit: 'Шығынды өңдеу',
    delete: 'Шығынды жою',
    deleteConfirm: 'Бұл шығынды жою керек пе?',
    noExpenses: 'Әзірге шығын жоқ',
    noExpensesHint: 'Бюджет есебін бастау үшін алғашқы шығынды қосыңыз',
    total: 'Барлығы',
    monthTotal: 'Ай ішінде',
    weekTotal: 'Апта ішінде',
    filterStatus: 'Статус',
    filterCategory: 'Санат',
    filterPayee: 'Алушы түрі',
    filterMethod: 'Төлем тәсілі',
    resetFilters: 'Сүзгілерді тазалау',
    statusDraft: 'Жоспарлануда',
    statusPending: 'Төлемді күтуде',
    statusPaid: 'Төленді',
    statusCancelled: 'Болдырылмады',
    payeeContractor: 'Мердігер',
    payeeOther: 'Басқа',
    methodCash: 'Қолма-қол',
    methodCard: 'Карта',
    methodTransfer: 'Аударым',
    methodInvoice: 'Шот',
    amount: 'Сома',
    amountPlaceholder: 'Соманы енгізіңіз',
    descriptionPlaceholder: 'Не сатып алынды немесе не үшін төленді',
    contractorLabel: 'Мердігер',
    contractorPlaceholder: 'Атын таңдаңыз немесе енгізіңіз',
    storeLabel: 'Дүкен',
    storePlaceholder: 'Дүкен атауы',
    tagsLabel: 'Тегтер',
    chartTagSuggestions: 'Тегтер бойынша сүзгі',
    chartTagSuggestionsHint: 'Қажетті белгісі бар шығындарды көрсетіңіз',
    filterByTag: '{{tag}} тегі бойынша сүзу',
    clearTagFilter: '{{tag}} тегі бойынша сүзгіні алып тастау',
    tagsPlaceholder: 'Мысалы: прораб-алексей, құрылыс-дүкені',
    tagsFilterTitle: 'Сүзгілерді өзіңізге бейімдеңіз',
    tagsFilterDescription: 'Шығындарды дәлірек сүзу үшін өз белгілеріңізді қосыңыз — мысалы, прорабтың аты немесе дүкен атауы бойынша.',
    tagsUsedLabel: 'Бұрын қолданылған',
    tagsHint: 'Тегтерді үтірмен немесе бос орынмен бөліңіз',
    receipt: 'Чек / фото',
    uploadReceipt: 'Фото тіркеу',
    paymentDate: 'Төлем күні',
    chartCategory: 'Санаттар бойынша',
    chartStatus: 'Статустар бойынша',
    aiNoSuggestions: 'Кеңес жоқ — көбірек шығын қосыңыз',
    aiSuggest: 'Санатты ұсыну',
    receivedFrom: 'Алушы',
    chartLabel: 'Жиынтық',
    showChart: 'Графикті көрсету',
    hideChart: 'Графикті жасыру',
    perCategory: 'Санаттар бойынша',
    groupByMonth: 'Айлар бойынша',
    groupByWeek: 'Апталар бойынша',
    groupByDay: 'Күндер бойынша',
    allCategories: 'Барлық санаттар',
    subcategory: 'Ішкі санат',
    paid: 'Төленді',
    tabPaid: 'Төленген',
    tabPlanned: 'Жоспарлы',
    drafts: 'Жоспарлы шығындар',
    spend: 'Шығындар',
    aiAnalyzingProject: 'Прораб AI жобаны талдап жатыр...',
    retry: 'Қайталау',
    aiNoNewIdeas: 'Прораб AI жаңа идея таппады — бәрі ескерілген сияқты!',
    noExpensesFiltered: 'Таңдалған сүзгілер бойынша шығын жоқ',
    noPlannedExpenses: 'Жоспарлы шығын жоқ',
    addFirst: 'Алғашқы шығынды қосу',
    draftsPlanned: 'Жоспарлы шығындар',
    hideList: 'Тізімді жасыру',
    showList: 'Көрсету ({{count}})',
    unnamed: 'Атаусыз',
    advance: 'Төлем бөлігі',
    filterPartlyPaid: 'Ішінара төленген',
    plannedTotal: 'Жоспарланған',
    selectMode: 'Таңдау',
    selectDone: 'Дайын',
    selectAll: 'Барлығын таңдау',
    selectNone: 'Таңдауды алу',
    selectHint: 'Шығындарды белгілеңіз — соманы есептейміз',
    selectedCount: '{{total}} ішінен {{count}} таңдалды',
    fullPrice: 'Толық құны',
    paidByAdvance: 'Төленді',
    remainder: 'Қалдық',
    paymentProgress: 'Шығынды төлеу',
    advanceAmountLabel: 'Төлем сомасы',
    editAdvance: 'Төлем бөлігін өңдеу',
    remainderHint: 'Төленді {{paid}} · қалдық {{remainder}}',
    fullPriceBelowAdvances: 'Толық құны төленген сомадан жоғары болуы керек',
    advancePaid: 'төленді {{paid}} / {{total}}',
    pay: 'Төлеу',
    toTop: 'Жоғары',
    payAdvance: 'Төлем бөлігін енгізу',
    advanceHint: 'Көрсетілген бөлігі төленген болады, қалғаны жоспарда қалады.',
    createCopy: 'Көшірме жасау',
    copiedTitle: 'Шығын көшірмесі',
    newTitle: 'Жаңа шығын',
    basicInfo: 'Негізгі ақпарат',
    expenseName: 'Шығын атауы',
    expenseNamePlaceholder: 'Мысалы: плиткаға аванс',
    note: 'Ескертпе',
    notePlaceholder: 'Мысалы: қандай жұмыстар үшін немесе төлем мәліметтері',
    paymentDetails: 'Төлем мәліметтері',
    paidTo: 'Кімге төленді',
    draftToggle: 'Бұл жоспарлы шығын',
    draftHint: 'Әлі төленбеген және өзгеруі мүмкін. Жоспарға кіреді, нақты шығынға емес. Бір бөлігін төлегенде аванс белгілейсіз, қалғаны жоспарда қалады.',
    extra: 'Қосымша',
    paymentHistory: 'Төлем тарихы',
    remainingDraft: 'Жоспардағы қалдық',
    mainPayment: 'Негізгі төлем',
    linkedExpense: 'Байланысты шығын',
    invalidAmount: 'Дұрыс соманы енгізіңіз',
    nameRequired: 'Шығын атауын енгізіңіз',
    saveError: 'Сақтау қатесі',
    loadError: 'Шығынды жүктеу мүмкін болмады',
    deleteError: 'Жою мүмкін болмады',
    uncategorized: 'Санатсыз',
    noSubcategory: 'Ішкі санатсыз',
    categories: {
      'Стройматериалы': 'Құрылыс материалдары',
      'Работы': 'Жұмыстар',
      'Техника и оборудование': 'Техника және жабдық',
      'Услуги': 'Қызметтер',
      'Прочее': 'Басқа',
      'Еда и продукты': 'Тамақ және өнімдер',
      'Транспорт': 'Көлік',
      'Жильё и ЖКУ': 'Тұрғын үй және коммуналдық',
      'Здоровье': 'Денсаулық',
      'Развлечения': 'Ойын-сауық',
      'Одежда и уход': 'Киім және күтім',
      'Образование': 'Білім',
      'Техника и гаджеты': 'Техника және гаджеттер',
      'Маркетплейсы': 'Маркетплейстер',
      'Путешествия': 'Саяхат',
      'Кофе': 'Кофе',
    },
  },
  stages: {
    ...ru.stages,
    title: 'Кезеңдер',
    add: 'Жаңа кезең',
    addItem: 'Жаңа пункт',
    delete: 'Кезеңді жою',
    deleteConfirm: 'Бұл кезеңді жою керек пе?',
    deleteWithItemsConfirm: 'Кезеңді жою керек пе? Кезеңнің барлық тапсырмалары да жойылады.',
    deleteItemConfirm: 'Бұл пунктті жою керек пе?',
    notFound: 'Кезең табылмады',
    noStages: 'Әзірге кезең жоқ',
    noStagesHint: 'Кезеңдерді қолмен жасаңыз немесе дайын үлгіні қолданыңыз',
    fromTemplate: 'Үлгіден',
    titleLabel: 'Кезең атауы',
    titlePlaceholder: 'Мысалы: Электрика',
    descriptionLabel: 'Сипаттама',
    descriptionPlaceholder: 'Бұл кезеңге не кіреді',
    responsibleLabel: 'Жауапты',
    responsiblePlaceholder: 'Мердігер немесе команда мүшесі',
    deadlineLabel: 'Дедлайн',
    progressLabel: 'Прогресс',
    statusNotStarted: 'Басталмаған',
    statusInProgress: 'Жұмыста',
    statusCompleted: 'Аяқталды',
    statusBlocked: 'Бұғатталған',
    showCompleted: 'Аяқталғандарды көрсету',
    hideCompleted: 'Аяқталғандарды жасыру',
    items: 'Пункттер',
    noItems: 'Әзірге пункт жоқ',
    itemTitleLabel: 'Не істеу керек',
    itemTitlePlaceholder: 'Пункт сипаттамасы',
    addItemPlaceholder: 'Тапсырма қосу...',
    itemDone: 'Орындалды',
    changeStatus: 'Статусты өзгерту',
    templates: 'Кезең үлгілері',
    templateApply: 'Үлгіні қолдану',
    selectAll: 'Барлығын таңдау',
    deselectAll: 'Таңдауды алу',
    applyingTemplate: 'Қолданылуда...',
  },
  kanban: {
    title: 'Канбан',
    columnTodo: 'Орындалуы керек',
    columnDoing: 'Жұмыста',
    columnDone: 'Дайын',
    columnBlocked: 'Бұғатталған',
    empty: 'Бос',
    move: 'Жылжыту',
  },
  needCategories: {
    ...ru.needCategories,
    FLOORING: 'Еден жабындары',
    TILES: 'Плитка',
    PLUMBING: 'Сантехника',
    LIGHTING: 'Жарықтандыру',
    ELECTRICAL: 'Электрика',
    DOORS: 'Есіктер',
    KITCHEN: 'Асүй және техника',
    WALLS_CEILING: 'Қабырға және төбе',
    WINDOWS_TEXTILE: 'Терезе және текстиль',
    FURNITURE: 'Жиһаз',
    ELECTRONICS: 'Электроника',
    CLIMATE: 'Климат',
    SECURITY: 'Қауіпсіздік',
    STORAGE: 'Сақтау',
    GARDEN: 'Бақ және учаске',
    CLEANING: 'Тазалау',
    TOOLS: 'Құралдар',
    DECOR: 'Декор',
    TEXTILE: 'Текстиль',
    BATH: 'Жуынатын бөлме',
    OTHER: 'Басқа',
  },
  materials: {
    ...ru.materials,
    title: 'Материалдар',
    add: 'Жаңа материал',
    delete: 'Жою',
    deleteConfirm: 'Материалды жою керек пе?',
    noMaterials: 'Әзірге ештеңе қосылмаған',
    noMaterialsHint: 'Сатып алу тізімін жасаңыз немесе үлгіні қолданыңыз',
    fromTemplate: 'Үлгіден',
    statusActive: 'Жұмыста',
    statusBought: 'Сатып алынды',
    statusCancelled: 'Болдырылмады',
    nameLabel: 'Атауы',
    namePlaceholder: 'Мысалы: ваннаға плитка',
    quantityLabel: 'Саны',
    unitLabel: 'Өлш. бірл.',
    categoryLabel: 'Санат',
    priorityLabel: 'Басымдық',
    priorityLow: 'Төмен',
    priorityMedium: 'Орташа',
    priorityHigh: 'Жоғары',
    notesLabel: 'Жазбалар',
    notesPlaceholder: 'Қосымша ақпарат',
    options: 'Нұсқалар',
    addOption: 'Нұсқа қосу',
    optionTitlePlaceholder: 'Атауы (бренд, модель)',
    optionPricePlaceholder: 'Баға (міндетті емес)',
    optionUrlPlaceholder: 'Тауар сілтемесі',
    linkHint: 'Кез келген дүкеннен тауар сілтемесін қойыңыз — атауын, бағасын және фотосын өзіміз толтырамыз.',
    pasteLink: 'Қою',
    fillManually: 'Сілтемесіз — қолмен толтыру',
    optionDescriptionPlaceholder: 'Сипаттама (міндетті емес)',
    previewLoading: 'Тауар бетін оқып жатыр…',
    previewFailed: 'Бетті оқу мүмкін болмады — қолмен толтырыңыз',
    previewEmpty: 'Бетте тауар деректері табылмады — қолмен толтырыңыз',
    previewFilled: 'Толтырылды: {{fields}} — тексеріп, сақтаңыз',
    previewForeignCurrency: 'Беттегі баға {{currency}}, ал жоба {{project}} — бағаны өзіңіз енгізіңіз',
    previewField: { title: 'атауы', price: 'баға', description: 'сипаттама', image: 'фото' },
    optionTitle: 'Атауы',
    optionPrice: 'Баға',
    optionUrl: 'Сілтеме',
    optionNotes: 'Пікір',
    selectOption: 'Таңдау',
    deselectOption: 'Таңдауды алу',
    deleteOption: 'Нұсқаны жою',
    selected: 'Таңдалды',
    estimatedTotal: 'Бюджет бағдары',
    boughtTotal: 'Сатып алынған сома',
    templates: 'Үлгілер',
    applyTemplate: 'Үлгіні қолдану',
    selectItems: 'Пункттерді таңдаңыз',
    productCount_one: '{{count}} тауар',
    productCount_few: '{{count}} тауар',
    productCount_many: '{{count}} тауар',
    productCount_other: '{{count}} тауар',
    deleteAllConfirm: 'Барлық тауарды жою керек пе? Бұл әрекетті қайтару мүмкін емес.',
    productsTitle: 'Тауарлар',
    noProducts: 'Тауар жоқ',
    noProductsHint: 'Сатып алуды жоспарлау үшін тауар қосыңыз',
    chooseTemplate: 'Үлгіні таңдаңыз',
    selectedCount: 'Таңдалды: {{total}} ішінен {{selected}}',
    deselectAll: 'Барлығын алу',
    applySelected: '{{count}} тауарды қолдану',
    addOwnProduct: 'Немесе өз тауарыңызды қосыңыз',
    searchPlaceholder: 'Атауы бойынша іздеу...',
    nothingByFilters: 'Берілген сүзгілер бойынша ештеңе табылмады',
    selectedLabel: 'Таңдалды:',
    selectedOption: 'Таңдалған нұсқа',
    price: 'Баға',
    edit: 'Өңдеу',
    deleteProduct: 'Тауарды жою',
    productNotFound: 'Тауар табылмады',
    openLink: 'Сілтемені ашу →',
    adding: 'Қосылуда...',
    deleteOptionConfirm: 'Бұл нұсқаны жою керек пе?',
    optionsEmpty: 'Таңдап жатқан тауарларды осында сақтаңыз: сілтемені қойыңыз — атауы мен бағасын өзіміз толтырамыз. Таңдағаныңызды дөңгелекпен белгілеңіз.',
    removeImage: 'Фотоны алып тастау',
    uploadImage: 'Фото жүктеу',
    replaceImage: 'Фотоны ауыстыру',
    imageUploading: 'Фото жүктелуде…',
    imageUploadFailed: 'Фотоны жүктеу мүмкін болмады',
    dragToReorder: 'Ретін өзгерту үшін сүйреңіз',
    reorderFailed: 'Ретін сақтау мүмкін болмады',
    compareView: 'Салыстыру',
    listView: 'Тізіммен',
    priceAboveCheapest: 'Ең арзанынан +{{amount}}',
    compareNoPrice: 'Бағасы көрсетілмеген',
    cheapest: 'Ең арзан',
    deleteProductConfirm: 'Тауарды жою керек пе? Барлық нұсқалар да жойылады.',
    collectionsTitle: 'Іріктемелер',
    newCollection: 'Жаңа іріктеме',
    collectionNameLabel: 'Не таңдап жатырсыз?',
    collectionNamePlaceholder: 'Мысалы: Асүйге араластырғыш',
    collectionsEmpty: 'Іріктемелер әлі жоқ',
    collectionsEmptyHint: 'Іріктеме — сіз таңдап жатқан тауарлар: араластырғыштар, плитка, шамдар. Дүкен сілтемесін қойыңыз — атауын, бағасын және фотосын өзіміз толтырамыз.',
    onboarding: {
      title: 'Тауарды шатаспай таңдаңыз',
      lead: 'Іріктеме — әртүрлі дүкендердегі бір сатып алудың нұсқалары: араластырғыштар, плитка, шамдар. Оларды бір жерде сақтап, салыстырып, шешкенде сатып алыңыз.',
      exampleTitle: 'Асүйге арналған араластырғыш',
      exampleFrom: '3 тауар · 39 900 ₸ бастап',
      exampleItems: [
        { name: 'Lemark Comfort LM3061C', shop: 'santehnika.kz', price: '39 900 ₸' },
        { name: 'Grohe Eurosmart 33281003', shop: 'Kaspi', price: '64 900 ₸' },
        { name: 'Hansgrohe Focus M41', shop: 'Wildberries', price: '77 000 ₸' },
      ],
      benefitLink: 'Дүкен сілтемесін қойыңыз — атауын, бағасын және фотосын өзіміз толтырамыз',
      benefitCompare: 'Нұсқаларды қатар салыстырыңыз — қайсысы арзан екені бірден көрінеді',
      benefitKeep: 'Сілтемелер чаттар мен қойындыларда жоғалмайды — сатып алар кезде ораласыз',
      startLabel: 'Қазір не таңдап жатырсыз?',
      starters: ['Араластырғыш', 'Ваннаға плитка', 'Ламинат', 'Люстра', 'Диван'],
      ownCollection: 'Өз іріктемем',
    },
    createCollection: 'Іріктеме жасау',
    collectionNoItems: 'Әзірге бос',
    collectionNotFound: 'Іріктеме табылмады',
    deleteCollection: 'Іріктемені жою',
    deleteCollectionConfirm: 'Іріктемені барлық тауарларымен бірге жою керек пе?',
    priceFrom: '{{price}} бастап',
    addProduct: 'Тауар қосу',
    buy: 'Сатып алу',
    removeProduct: 'Тауарды жою',
    removeProductConfirm: 'Тауарды іріктемеден жою керек пе?',
    productsEmptyHint: 'Тауар сілтемесін қойыңыз — атауын, бағасын және фотосын өзіміз толтырамыз.',
    nothingFound: 'Ештеңе табылмады',
    note: 'Ескертпе',
  },
  projects: {
    ...ru.projects,
    mainBlockLabel: 'Басты бетте не көрсету керек',
    mainBlockHint: 'Кейін «Басты бет баптауларында» өзгертуге болады',
    newTitle: 'Жаңа жоба',
    editTitle: 'Жоба баптаулары',
    deleteProject: 'Жобаны жою',
    deleteConfirm: 'Бұл жобаны қайтарымсыз жою керек пе?',
    titleLabel: 'Жоба атауы',
    titlePlaceholder: 'Мысалы: Жағалаудағы пәтер',
    typeRenovation: 'Жөндеу',
    typeFinance: 'Қаржы',
    financeDisclaimer: 'Бұл қолданбаның басқа режимі — өмірдегі қаржыны таза бақылау. Әзірше эксперимент ретінде.',
    budgetLabel: 'Бюджет',
    budgetPlaceholder: 'Сома',
    currencyLabel: 'Валюта',
    currencyNoConversion: 'Валютаны ауыстыру бұрын жасалған шығындар, материалдар және бюджет жолдарын қайта есептемейді.',
    areaLabel: 'Аудан (м²)',
    areaPlaceholder: 'Мысалы: 60',
    startDateLabel: 'Жөндеу басталған күн',
    startDateHint: 'Басты бетте жөндеудің ағымдағы күнін көрсету үшін қолданылады.',
    creating: 'Жасалуда...',
    saving: 'Сақталуда...',
    leaveProject: 'Жобадан шығу',
    leaveConfirm: 'Бұл жобадан шығасыз ба?',
  },
  members: {
    ...ru.members,
    title: 'Қатысушылар',
    invite: 'Шақыру',
    inviteLink: 'Шақыру сілтемесі',
    copy: 'Көшіру',
    copied: 'Көшірілді!',
    expiresIn: '{{days}} күн жарамды',
    revoke: 'Күшін жою',
    role: 'Рөл',
    roleOwner: 'Иесі',
    roleEditor: 'Редактор',
    roleViewer: 'Қонақ',
    you: 'сіз',
    remove: 'Жою',
    removeConfirm: 'Қатысушыны жою керек пе?',
    limitReached: 'Қатысушылар лимиті жетті ({{limit}})',
    pendingInvites: 'Белсенді шақырулар',
    activeMembers: 'Қазіргі қатысушылар',
    inviteAsRole: 'Рөлмен шақыру',
    expirationLabel: 'Жарамдылық мерзімі',
    expirationOptions: {
      day: '1 күн',
      week: '7 күн',
      month: '30 күн',
    },
    createInvite: 'Шақыру жасау',
    inviteCreated: 'Шақыру жасалды',
  },
  accept: {
    ...ru.accept,
    title: 'Жобаға шақыру',
    project: 'Жоба',
    invitedBy: 'Шақырған',
    role: 'Сіздің рөліңіз',
    accept: 'Шақыруды қабылдау',
    decline: 'Бас тарту',
    accepting: 'Қабылдануда...',
    accepted: 'Шақыруды қабылдадыңыз',
    expired: 'Шақыру мерзімі өтті',
    invalid: 'Шақыру жарамсыз',
  },
  budget: {
    ...ru.budget,
    title: 'Бюджет калькуляторы',
    desc: 'Жалпы бюджетті санаттарға бөліп, лимиттерді бақылаңыз',
    totalBudget: 'Жалпы бюджет',
    planned: 'Жоспарланған',
    leftToPlan: 'Бөлуге қалды',
    overPlanned: 'Артық жоспарланды',
    distributeRemainder: 'Қалғанын бөлу',
    distributing: 'Бөлінуде...',
    aiSuggest: 'AI ұсынсын',
    aiSuggesting: 'AI ойланып жатыр...',
    aiSuggestHint: 'AI бюджетті жоба түріне қарай бөледі',
    aiPromptLabel: 'Жобаны сипаттаңыз (міндетті емес)',
    aiPromptPlaceholder: 'Мысалы: 60 м² пәтер, таза әрлеу',
    saving: 'Сақталуда...',
    plannedLabel: 'Жоспар',
    spentLabel: 'Жұмсалды',
    percentLabel: 'бюджеттен %',
    addCategory: 'Санат қосу',
    deleteCategory: 'Жою',
    calculatorTitle: 'Бюджет калькуляторы',
    calculatorSubtitle: 'Бюджетті санаттарға бөліңіз',
    aiDistribution: 'AI бюджет бөлуі',
    aiAnalyzing: 'Талдануда...',
    availableIn: '{{time}} кейін қолжетімді',
    distributeWithAi: '✨ AI арқылы бөлу',
    planDistributed: 'Жоспар бойынша бөлінді',
    planTotal: 'Жоспар бойынша барлығы:',
    projectLimit: 'Жоба лимиті:',
    limitRemaining: 'Лимитке дейін қалды:',
    usage: 'Пайдалану:',
    pricePerSqm: 'м² бағасы:',
    plannedExpenseItems: 'Жоспарлы шығын баптары',
    deleteCategoryConfirm: '"{{category}}" санатын жою керек пе?',
    duplicateCategory: 'Мұндай атауы бар санат бар',
    loadPlanError: 'Жоспарды жүктеу қатесі',
    loadPlanFailed: 'Жоспарды жүктеу мүмкін болмады',
    saveError: 'Сақтау қатесі',
    distributeError: 'Бөлу қатесі',
    aiError: 'AI сұрауының қатесі',
    distributeRemainderAuto: 'Қалғанын автоматты бөлу',
  },
  support: {
    ...ru.support,
    title: 'Қолдау',
    desc: 'Мәселені сипаттаңыз немесе идеямен бөлісіңіз. Біз Telegram-ботта жауап береміз.',
    messageLabel: 'Хабарлама',
    messagePlaceholder: 'Не болды немесе нені жақсартқыңыз келеді?',
    contactLabel: 'Байланыс (міндетті емес)',
    contactPlaceholder: 'Telegram, email немесе телефон',
    send: 'Жіберу',
    sending: 'Жіберілуде...',
    sent: 'Рақмет! Хабарлама жіберілді.',
    error: 'Жіберу мүмкін болмады. Кейінірек қайталап көріңіз.',
    history: 'Сіздің өтініштеріңіз',
    noRequests: 'Әзірге өтініш жоқ',
    answered: 'Жауап',
  },
  reports: {
    title: 'Есептер',
    cardSubtitle: 'Жоба бойынша өткен есептер',
    markAllRead: 'Барлығын оқылды деп белгілеу',
    empty: 'Әзірге есеп жоқ. Олар алғашқы жіберілімнен кейін осында пайда болады.',
    untitledProject: 'Жоба',
    manual: 'Қолмен',
  },
  files: {
    title: 'Жоба файлдары',
    estimates: 'Сметалар',
    photos: 'Фотосуреттер',
    uploadEstimate: 'Сметаны жүктеу',
    uploadPhoto: 'Фото қосу',
    empty: 'Әзірге фотосурет жоқ.',
    emptyEstimates: 'Әзірге смета жоқ. Мердігерден PDF, Excel немесе сканерленген файл жүктеңіз.',
    download: 'Жүктеп алу',
    deleteConfirm: 'Бұл файлды жою керек пе?',
    tooLarge: 'Файл тым үлкен (максимум 15 МБ)',
    unsupportedType: 'Қолдау көрсетілмейтін файл форматы',
    quotaExceeded: 'Осы жоба үшін файл лимитіне жетті',
    disabled: 'Бұл жоба үшін файл жүктеу әлі теңшелмеген',
    parseToExpenses: 'Шығындарға тану',
    columnMapping: {
      description: 'Бағандарды сенімді анықтау мүмкін болмады — қолмен таңдаңыз.',
      descriptionColumn: 'Сипаттама',
      amountColumn: 'Сома',
      categoryColumn: 'Санат',
      confirm: 'Жалғастыру',
    },
    importReview: {
      selectAll: 'Барлығын таңдау',
      import: 'Импорттау ({{count}})',
    },
    importResult: {
      summary: '{{total}} ішінен {{success}} импортталды',
      errors: 'Өткізіп жіберілді: {{count}}',
    },
  },
  plans: {
    onboarding: {
      title: 'Пәтер жоспары бірнеше минутта',
      lead: 'Қабырғаларды сызыңыз — бөлмелер, аудандар және әрлеу көлемі өзі есептеледі. Содан кейін пәтерді 3D-де қараңыз.',
      exampleRooms: {
        'room-1': 'Жатын бөлме',
        'room-2': 'Ас үй-қонақ бөлме',
        'room-3': 'Жатын бөлме 2',
        'room-4': 'Жуынатын бөлме',
      },
      benefitDraw: 'Қабырғалар тор бойынша немесе жоспар фотосы бойынша — тұйық контур өзі ауданы бар бөлмеге айналады',
      benefitLayers: 'Жиһаз, розеткалар және сантехника — қабаттармен, «Авто» оларды бөлмелерге орналастырады',
      benefitFinish: 'Еден мен қабырға әрлеуі: смета үшін ойықтарсыз қабырға ауданы және плинтус ұзындығы',
      benefit3d: 'Жиһазы мен әрлеуі бар пәтердің 3D көрінісі',
      heroAlt: 'Мысал: жиһазы бар екі бөлмелі пәтер 3D-де',
      startLabel: 'Неден бастау',
      withFurniture: 'жиһазбен',
      blank: 'Нөлден',
      blankHint: 'Өз қабырғаларыңызды сызу немесе фотоны айналдыра сызу',
      viewerHint: 'Жоба иесі әлі жоспар қоспаған.',
    },
    tour: {
      label: 'Жоспарлаушыны қалай қолдану',
      open: 'Қалай қолдану',
      skip: 'Кеңестерді жабу',
      next: 'Әрі қарай',
      back: 'Артқа',
      done: 'Түсінікті',
      walls: {
        title: 'Қабырғаларды сызыңыз',
        text: '«Қабырға» құралы: басып, созыңыз — қабырға шығады. Бұрыштарды түрту қабырғаларды тізбекпен сызады. Жоспар фотосы бар ма — оны жоғарыдағы сурет батырмасымен жүктеңіз, AI қабырғаларды сызып береді.',
      },
      rooms: {
        title: 'Бөлмелер өзі пайда болады',
        text: 'Қабырғалардың тұйық контуры ауданы бар бөлмеге айналады. Бөлмені түртіңіз — атауы, еден мен қабырға әрлеуі, ойықтарсыз қабырға ауданы және плинтус.',
      },
      layers: {
        title: 'Жиһаз және инженерия',
        text: 'Қабатты ауыстырыңыз: жиһаз, электр, сантехника. Заттар — каталогтан, ал «Авто» оларды бөлмелерге өзі орналастырады.',
      },
      '3d': {
        title: '3D-де қараңыз',
        text: 'Жиһазы мен әрлеуі бар бүкіл пәтер. Саусақпен айналдырыңыз, қайшы жақын қабырғаларды кеседі.',
      },
    },
    title: 'Жоспарлар',
    cardSubtitle: 'Пәтер жоспарын салып, аудандарды есептеңіз',
    create: 'Жаңа',
    createFirst: 'Жоспар салу',
    defaultName: 'Жоспар {{n}}',
    emptyTitle: 'Әзірге жоспарлар жоқ',
    emptyText: 'Торға қабырғаларды салыңыз — тұйық контур өзі ауданы бар бөлмеге айналады.',
    deleteConfirm: '«{{name}}» жоспарын жою керек пе?',
    notFound: 'Жоспар табылмады',
    nameLabel: 'Жоспар атауы',
    saved: 'Сақталды',
    saving: 'Сақталуда…',
    saveError: 'Сақталмады',
    undo: 'Болдырмау',
    redo: 'Қайталау',
    zoomIn: 'Жақындату',
    zoomOut: 'Алыстату',
    view3d: '3D',
    view3dOpen: '3D-де көру',
    view3dTitle: 'Жоспардың 3D көрінісі',
    view3dClose: '3D жабу',
    view3dLabels: 'Бөлме атаулары',
    view3dCut: 'Жақын қабырғаларды кесу',
    wallsNet: 'Ойықтарсыз қабырғалар',
    baseboard: 'Плинтус',
    floorFinish: 'Еден',
    wallFinish: 'Қабырғалар',
    finishFloor: {
      WOOD: 'Паркет',
      LAMINATE: 'Ламинат',
      TILE: 'Плитка',
      STONE: 'Керамогранит',
      CARPET: 'Кілем жабын',
      CONCRETE: 'Бетон',
    },
    finishWall: {
      PAINT: 'Бояу',
      WALLPAPER: 'Тұсқағаз',
      TILE: 'Плитка',
      PLASTER: 'Сылақ',
      PANELS: 'Панельдер',
    },
    view3dReset: 'Көріністі қалпына келтіру',
    view3dSqm: 'м²',
    view3dEmpty: 'Қабырғаларды салыңыз — мұнда пәтердің көлемді моделі пайда болады',
    view3dHint: 'Сүйреңіз — айналдыру · оң батырма немесе екі саусақ — жылжыту · дөңгелек немесе қысу — масштаб',
    fit: 'Бүкіл жоспарды көрсету',
    toolSelect: 'Таңдау',
    toolWall: 'Қабырға',
    done: 'Дайын',
    hintEmpty: '«Қабырға» таңдап, торға нүктелер қойыңыз',
    emptyReadOnly: 'Жоспар әзірге бос',
    hintWallStart: 'Басып тұрып тартыңыз — қабырға соңында жіберіңіз. Немесе бұрыштарды басып қойыңыз',
    hintWallNext: 'Келесі бұрыш. Контурды тұйықтасаңыз — бөлме пайда болады',
    roomDefault: 'Бөлме {{n}}',
    roomName: 'Бөлме атауы',
    wall: 'Қабырға',
    length: 'Ұзындығы',
    wallAngle: 'Көкжиекке еңкею',
    cornerAngle: 'Түйіскен жердегі бұрыш ({{side}})',
    side: { left: 'сол жақ', right: 'оң жақ', top: 'үсті', bottom: 'асты' },
    angleHint: 'Еңкею қабырғаны ортасынан айналдырады. Түйіскен бұрыш осы қабырғаны өзгертеді, көрші қабырға орнында қалады.',
    thickness: 'Қалыңдығы',
    area: 'Ауданы',
    perimeter: 'Периметрі',
    unitM: 'м',
    unitM2: 'м²',
    roomsCount_one: '{{count}} бөлме',
    roomsCount_other: '{{count}} бөлме',
    bgTitle: 'Фон-фото',
    bgAdd: 'Фото қосу',
    bgReplace: 'Фотоны алмастыру',
    bgOpacity: 'Мөлдірлігі',
    bgLock: 'Бекіту',
    bgUnlock: 'Босату',
    bgLockedHint: 'Бекітілген — жылжыту және өлшемін өзгерту өшірілген',
    bgDeleteConfirm: 'Фон-фотоны жою керек пе?',
    chooseTemplate: 'Неден бастаймыз?',
    templateBlank: 'Бос жоспар',
    templateBlankHint: 'Қабырғаларды нөлден салу',
    templateStudio: 'Студия',
    templateOneRoom: 'Бір бөлмелі',
    templateTwoRoom: 'Екі бөлмелі',
    newWallThickness: 'Қабырға қалыңдығы, см',
    thicknessCustom: 'Өз қалыңдығы',
    unitCm: 'см',
    unitMm: 'мм',
    lengthUnit: 'Ұзындық бірлігі',
    roomAutoHint: 'Бөлме қабырғалар бойынша анықталады: өзгерту не жою үшін қабырғаларды жылжытыңыз не жойыңыз.',
    toolDoor: 'Есік',
    toolWindow: 'Терезе',
    hintDoor: 'Есік қою үшін қабырғаны басыңыз',
    hintWindow: 'Терезе қою үшін қабырғаны басыңыз',
    doorWidth: 'Есік ені, см',
    windowWidth: 'Терезе ені, см',
    widthCustom: 'Өз ені',
    width: 'Ені',
    door: 'Есік',
    window: 'Терезе',
    doorFlipHinge: 'Топсаларды екінші жаққа',
    doorFlipSide: 'Ашылуын екінші жаққа',
    openingFromCorner: 'Қабырға басынан',
    openingTapWall: 'Қабырғаның өзін басыңыз',
    openingWallTooShort: 'Қабырға ойық үшін тым қысқа',
    openingOverlap: 'Мұнда ойық бар — басқа орын таңдаңыз',
    cmValue: '{{value}} см',
    roomsList: 'Бөлмелер',
    roomsEmpty: 'Әзірге бөлмелер жоқ — қабырғаларды тұйықтаңыз, олар осында пайда болады.',
    layers: 'Қабаттар',
    layerPlan: 'Жоспар',
    layerPlanHint: 'Қабырғалар, есіктер, терезелер, бөлмелер',
    layerFurniture: 'Жиһаз',
    layerEditing: 'Қазір өңделуде',
    layersHide: 'Қабаттарды жасыру',
    room: 'Бөлме',
    walls: 'Қабырғалар',
    openings: 'Есіктер мен терезелер',
    layerShow: 'Қабатты көрсету',
    layerHide: 'Қабатты жасыру',
    layersHint: 'Өңдеу үшін қабатты басыңыз. Қалғандары күңгірт көрінеді және кедергі жасамайды.',
    itemsCount_one: '{{count}} зат',
    itemsCount_other: '{{count}} зат',
    addFurniture: 'Қосу',
    hintFurniture: 'Жиһаз орналастыру үшін «Қосу» басыңыз',
    rotateLeft: 'Сағат тіліне қарсы бұру',
    rotateRight: 'Сағат тілімен бұру',
    duplicate: 'Көшірме жасау',
    itemWidth: 'Ені',
    itemDepth: 'Тереңдігі',
    itemRotation: 'Бұрылыс',
    catalogSearch: 'Атауы бойынша іздеу',
    layerElectrical: 'Электр',
    layerPlumbing: 'Сантехника',
    hintElectrical: '«Қосу» басыңыз — розеткалар мен ажыратқыштар қабырғаға жабысады',
    hintPlumbing: '«Қосу» басыңыз — су және кәріз шығыстары қабырғаға жабысады',
    catalogFurniture: 'Жиһаз қосу',
    catalogElectrical: 'Электр қосу',
    catalogPlumbing: 'Сантехника қосу',
    itemElevation: 'Еденнен биіктігі',
    autoArrange: 'Авто',
    autoReplaceConfirm: '«{{layer}}» қабатын қайта орналастыру керек пе? Қазіргі заттар ауыстырылады — ↶ арқылы болдырмауға болады.',
    autoDone_one: '{{count}} зат орналастырылды — қолмен түзетіңіз не ↶ болдырмаңыз',
    autoDone_other: '{{count}} зат орналастырылды — қолмен түзетіңіз не ↶ болдырмаңыз',
    autoEmptyFurniture: 'Орналастыратын ештеңе жоқ: қабырғаларды бөлмелерге тұйықтап, атау беріңіз (Жатын бөлме, Ас үй…)',
    autoEmptyElectrical: 'Орналастыратын ештеңе жоқ: алдымен бөлмелер мен есіктерді салыңыз',
    autoEmptyPlumbing: 'Алдымен «Жиһаз» қабатына сантехника қойыңыз (ванна, қолжуғыш, унитаз…)',
    toolPassage: 'Өтпе',
    toolBalcony: 'Балкон',
    toolDivider: 'Аймақ шекарасы',
    hintDividerStart: 'Қабырғасыз аймақтар арасына шекара сызыңыз — мысалы, дәліз бен ас үй-қонақ бөлме',
    traceHint: 'Сызбадағы қабырғаларды, есіктер мен терезелерді табады; масштабты AI жазылған өлшемдерден оқиды. Анық жоспарларда жақсы жұмыс істейді; көлбеу қабырғалар табылмайды.',
    traceFound: 'Табылған қабырғалар: {{count}}',
    traceLongest: 'Ең ұзын қабырғаның ұзындығы',
    traceScaleHint: 'Фотода өлшем бірліктері жоқ: масштабты орнату үшін ең ұзын қабырғаның нақты ұзындығын енгізіңіз.',
    traceApply: 'Қабырғаларды сызу',
    traceReplaceConfirm: 'Жоспарда қабырғалар бар — оларды табылғандармен ауыстыру керек пе?',
    aiCheckBtn: 'AI арқылы сызу',
    aiCheckRunning: 'AI сызып жатыр…',
    aiCheckFailed: 'Фотоны тану мүмкін болмады',
    aiScaleUnavailable: 'AI қолжетімсіз — масштабты қолмен орнатыңыз',
    aiScaleHint: 'Масштаб жоспарда жазылған өлшем бойынша алынды — ең ұзын қабырғаның ұзындығын тексеріп, қажет болса түзетіңіз.',
    aiCheckTitle: 'AI қорытындысы',
    aiCheckWalls: 'Қабырғалар көрінеді',
    aiCheckDimensions: 'Өлшемдер жазылған',
    aiCheckThickness: 'Қабырға қалыңдығы түсінікті',
    ceilingHeight: 'Төбе биіктігі',
    ceilingApplyAll: 'Барлығына қолдану',
    wallsArea: 'Қабырға ауданы',
    volume: 'Көлем',
    unitM3: 'м³',
    toolRuler: 'Сызғыш',
    hintRulerItem: 'Заттың үстін басыңыз — одан қабырғаларға және жиһазға дейінгі қашықтықты көрсетемін',
    hintRulerA: 'Бірінші нүктені басыңыз: қабырға бұрышы немесе зат шеті',
    hintRulerB: 'Екінші нүктені басыңыз',
    rulerModeItem: 'Заттан',
    rulerModePoints: 'Екі нүкте',
    hintPassage: 'Есіксіз өтпе жасау үшін қабырғаны басыңыз',
    hintBalcony: 'Сыртқы қабырғаны басыңыз — балкон оның сыртқы жағына қойылады',
    passageWidth: 'Өтпе ені, см',
    passage: 'Өтпе',
    balconyWidth: 'Балкон ені',
    balconyDepth: 'Балкон тереңдігі',
    balconyDefault: 'Балкон',
    balconyDefaultN: 'Балкон {{n}}',
    balconyShort: 'балкон',
    balconyTapWall: 'Сыртқы қабырғаның өзін басыңыз',
    balconyInnerWall: 'Балконды тек сыртқы қабырғаға қоюға болады',
    balconyNoSpace: 'Мұнда бос емес — басқа орын таңдаңыз',
    outdoorBadge: 'жалпыға кірмейді',
    outdoorHint: 'Балкон бөлек есептеледі және жалпы ауданға кірмейді. Ол қоршауға сүйенеді: қоршауды алсаңыз — қарапайым бөлме болады.',
    railing: 'Балкон қоршауы',
    railingHint: 'Қабырға орнына қоршау: онымен тұйықталған контур — балкон, жалпы ауданға кірмейді',
    divider: 'Аймақ шекарасы',
    dividerToggle: 'Қабырғасыз — аймақ шекарасы',
    dividerHint: 'Ашық кеңістікті бөлмелерге бөледі: қалыңдығы жоқ, ауданды азайтпайды, 3D-де көрінбейді',
  },
  catalog: {
    category: {
      living: 'Қонақ бөлме',
      bedroom: 'Жатын бөлме',
      kitchen: 'Ас үй және асхана',
      bathroom: 'Санторап',
      other: 'Басқа',
      hallway: 'Дәліз',
      sockets: 'Розеткалар',
      switches: 'Ажыратқыштар',
      lighting: 'Жарықтандыру',
      equipment: 'Жабдық',
      water: 'Сумен жабдықтау',
      sewerage: 'Кәріз',
    },
    sofa3: '3 орындық диван',
    sofa2: '2 орындық диван',
    cornerSofa: 'Бұрыштық диван',
    armchair: 'Кресло',
    coffeeTable: 'Журнал үстелі',
    tvStand: 'ТВ тумбасы',
    shelf: 'Сөре',
    plant: 'Өсімдік',
    doubleBed: 'Екі кісілік төсек',
    singleBed: 'Бір кісілік төсек',
    nightstand: 'Тумбочка',
    wardrobe: 'Шкаф',
    dresser: 'Комод',
    kitchenCounter: 'Ас үй гарнитуры',
    stove: 'Плита',
    fridge: 'Тоңазытқыш',
    kitchenSink: 'Жуғыш',
    diningTable: 'Ас үстелі',
    roundTable: 'Дөңгелек үстел',
    chair: 'Орындық',
    bathtub: 'Ванна',
    shower: 'Душ',
    toilet: 'Унитаз',
    washbasin: 'Қолжуғыш',
    washer: 'Кір жуғыш машина',
    desk: 'Жұмыс үстелі',
    officeChair: 'Кеңсе креслосы',
    pouf: 'Пуф',
    sideboard: 'Буфет',
    bookcase: 'Кітап шкафы',
    rug: 'Кілем',
    floorLamp: 'Торшер',
    kingBed: 'Төсек 180×200',
    kidsBed: 'Балалар төсегі',
    crib: 'Нәресте төсегі',
    vanityTable: 'Айналы үстел',
    slidingWardrobe: 'Купе шкафы',
    dishwasher: 'Ыдыс жуғыш машина',
    oven: 'Пеш',
    kitchenIsland: 'Ас үй аралы',
    cornerKitchen: 'Бұрыштық гарнитур',
    barStool: 'Бар орындығы',
    smallBathtub: 'Ванна 150 см',
    showerTray: 'Душ табаны',
    bidet: 'Биде',
    doubleSink: 'Қос қолжуғыш',
    dryer: 'Кептіргіш машина',
    waterHeater: 'Су жылытқыш',
    towelRail: 'Сүлгі кептіргіш',
    shoeCabinet: 'Аяқкиім шкафы',
    hallWardrobe: 'Дәліз шкафы',
    bench: 'Банкетка',
    coatRack: 'Ашық ілгіш',
    radiator: 'Радиатор',
    piano: 'Пианино',
    treadmill: 'Жүгіру жолы',
    socket: 'Розетка',
    socketDouble: 'Қос розетка',
    socketKitchen: 'Үстел үстіндегі розетка',
    socketWaterproof: 'Ылғалдан қорғалған розетка',
    socketPower: 'Күштік розетка (плита)',
    tvSocket: 'ТВ розетка',
    lanSocket: 'Интернет розетка',
    switch: 'Ажыратқыш',
    switchDouble: 'Екі пернелі ажыратқыш',
    switchPass: 'Өтпелі ажыратқыш',
    dimmer: 'Диммер',
    ceilingLight: 'Төбе шамы',
    chandelier: 'Аспашам',
    spotLight: 'Нүктелі шам',
    sconce: 'Бра',
    ledStrip: 'LED таспа',
    electricalPanel: 'Электр қалқаны',
    junctionBox: 'Тарату қорабы',
    thermostat: 'Терморегулятор',
    floorHeating: 'Жылы еден',
    airConditioner: 'Кондиционер',
    exhaustFan: 'Сорғыш желдеткіш',
    intercom: 'Домофон',
    waterCold: 'Суық су',
    waterHot: 'Ыстық су',
    waterRiser: 'Су тірегі',
    valve: 'Кран',
    waterMeter: 'Су есептегіші',
    sewerOutlet: 'Кәріз шығысы',
    sewerRiser: 'Кәріз тірегі',
    floorDrain: 'Трап',
    manifold: 'Коллектор',
    waterFilter: 'Су сүзгісі',
    heatingBoiler: 'Қазандық',
  },
  yandex: {
    ...ru.yandex,
    title: 'Яндекс арқылы авторизация',
    redirecting: 'etap-қа бағытталуда...',
    error: 'Авторизация қатесі',
    cancelled: 'Авторизация болдырылмады',
    retry: 'Қайталап көру',
  },
  editor: {
    ...ru.editor,
    bold: 'Қалың',
    italic: 'Курсив',
    underline: 'Асты сызылған',
    bulletList: 'Маркерленген тізім',
    orderedList: 'Нөмірленген тізім',
    taskList: 'Чек-лист',
    link: 'Сілтеме',
    unlink: 'Сілтемені жою',
    h1: 'Тақырып 1',
    h2: 'Тақырып 2',
    h3: 'Тақырып 3',
    placeholder: 'Жаза бастаңыз...',
  },
} as const;
